/* Imports */
import React from "react"
import { Grid, CardImage } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const CardImagePage = () => {
    const items = [
        {
            title: "",
            content: (
                <Grid col={2} gap="s">
                    <CardImage src="/images/pic-card.jpg" alt="Card" title="Title" />
                    <CardImage src="/images/pic-card.jpg" alt="Card" title="Title" to="#" fajnyIcon="play-solid" />
                </Grid>
            ),
            code: '<CardImage src="/images/pic-card.jpg" alt="Card" title="Title" />\n<CardImage src="/images/pic-card.jpg" alt="Card" title="Title" to="#" fajnyIcon="play-solid" />',
        },
    ]

    const propsItems = [
        {
            name: "title",
            type: "String",
            example: "Article",
            required: "Yes",
        },
        {
            name: "src",
            type: "String",
            example: "/images/cover-article.jpg",
            required: "Yes",
        },
        {
            name: "alt",
            type: "String",
            example: "Cover article",
            required: "Yes",
        },
        {
            name: "to",
            type: "String",
            example: "/article",
            required: "Yes",
        },
        {
            name: "icon",
            type: "String",
            example: "play",
        },
        {
            name: "fajnyIcon",
            type: "String",
            example: "play-regular",
            possible: commonProps.fajnyIcons,
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default CardImagePage
